import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import EditableField from './EditableField';
import EditableDropdown from './EditableDropdown';
import EditableSubject from './EditableSubject';
import { matchesSimpleString, matchesDateString } from '../helpers/Validations';
import { SIMPLE_STRING, DATE_STRING } from '../constants/ValidationWarnings';

export default class ProjectMetadata extends React.PureComponent {
  // a parent component can specify that one field is being edited as soon as
  // the component loads, i.e., the project code during project creation
  constructor(props, context) {
    super(props);
    this.state = {
      editingFields: context.editingFields || [],
    }
  }

  getFields() {
    return [
      {
        title: 'Code',
        attr: 'code',
        text: this.props.code,
        validation: matchesSimpleString,
        warning: SIMPLE_STRING,
        editTitle: 'Enter a project code',
      },
      {
        title: 'Title',
        attr: 'title',
        text: this.props.title,
        editTitle: 'Enter a title',
      },
      {
        title: 'Publisher',
        attr: 'publisher',
        text: this.props.publisher,
        editTitle: 'Enter a publisher',
      },
      {
        title: 'Rights',
        attr: 'rights',
        text: this.props.rights,
        editTitle: 'Enter the copyright statement, typically, "All rights reserved."',
      },
    ];
  }

  isBeingEdited = (name) => {
    return this.state.editingFields.includes(name);
  }

  // if a field that was being edited at first is updated, the field is no
  // longer being edited and can return to normal ("clear editing" becomes
  // available)
  update = (id, attr, value) => {
    if (this.state.editingFields.includes(attr)) {
      this.setState({
        editingFields: this.state.editingFields.filter(e => e !== attr)
      });
    }
    this.props.projectUpdate(attr, value);
  }

  tableRow(field) {
    const edited = this.isBeingEdited(field.attr);
    return (<tr key={field.attr} id={`${field.attr}-row`}>
      <td className="section-table-head">{field.title}</td>
      <td id={field.attr}>
        <EditableField
          itemRef={field.attr}
          text={field.text}
          title={field.editTitle}
          limit={40}
          editing={edited}
          clearDisabled={edited}
          update={this.update}
          validate={field.validation ? field.validation : () => true}
          warning={field.warning ? field.warning : 'Does not match expectations.'}
        />
      </td>
    </tr>);
  }

  render() {
    return (<div className="section-list" id='project-metadata'>
      <div className="section-header">
        <h2>General</h2>
      </div>
      <Table
        className="section-table"
        responsive
        hover
      >
        <tbody>
          {this.getFields().map(field => this.tableRow(field))}
          <tr>
            <td className="section-table-head">Subjects</td>
            <td id="subjects">
              <EditableSubject
                key="subjects"
                name="subjects"
                subjects={this.props.subjects}
                subjectData={this.props.subjectData}
                update={this.props.projectUpdate}
              />
            </td>
          </tr>
          <tr>
            <td className="section-table-head">Cover</td>
            <td id="cover">
              {this.props.imageFiles && this.props.imageFiles.length > 0 ?
              <EditableDropdown
                key="cover"
                itemRef="cover"
                name="cover"
                title="Select a cover"
                value={this.props.cover}
                options={this.props.imageFiles}
                update={(id, attr, value) => this.props.projectUpdate(attr, value)}
              /> : <span className="editable-field">
                  <span className="empty-field text-muted">
                    [Add images to select cover]
                </span>
              </span>}
            </td>
          </tr>
        </tbody>
      </Table>
    </div>);
  }
}

ProjectMetadata.contextTypes = {
  editingFields: PropTypes.array,
}
